import * as React from "react";
import { useTranslation } from "react-i18next";
import { useWindowDimensions, StyleSheet } from "react-native";
import { Paragraph, TextInput, useTheme, ActivityIndicator, Title } from "react-native-paper";
import { useDispatch, useSelector } from "react-redux";
import {
  getHeaderLeft,
  getHeaderRight,
  handlerListBene,
  PROFILE_BENE,
  TYPE_CHOOSE_BENE,
} from "../../../../modules/beneficiaries/utils/bene.utils";
import { fetchListBeneRequest } from "../../../../modules/beneficiaries/reducer/actions";
import { getListBeneSelector, getPendingBeneSelector } from "../../../../modules/beneficiaries/reducer/selectors";
import { Constant } from "../../../constant/constant";
import { ACCOUNT, TRANSPROFILE } from "../../../services/services-model.type";
import { spacing } from "@styles/spacing";
import { formatCurrency } from "../../../util/format-currency";
import { useMobileMediaQuery } from "@media-query";
import { Block } from "@block";
import ItemBeneAccountModal from "./item/item-content";
import { RecyclerListView, DataProvider, LayoutProvider } from "recyclerlistview";
import { LIMIT_BENE } from "../../../../modules/beneficiaries/services/bene.service";
import { mapAccountPayments } from "app/shared/util/common";
import { getListAccountSelector } from "app/modules/account-management/reducer/selectors";
// import { handlerListBeneficiaries } from "app/modules/beneficiaries/utils/beneficiaries.utils";

interface BeneAccountsModalProps {
  title?: string;
  account?: ACCOUNT;
  templateType?: string;
  onPressAcceptAccount?: Function;
  onPressAcceptBene?: Function;
}

export interface FlatListItem {
  data?: ACCOUNT | PROFILE_BENE;
  type?: string;
  label?: string;
  value?: string;
  header?: { left: string; right: string };
  alphabet?: string;
}

const ViewTypes = {
  HEADER: 0,
  LISTITEM: 1,
};

let arrayHeader: Array<number> = [];

const SelectAccountsBeneModal = (props: BeneAccountsModalProps) => {
  const { title, account, templateType, onPressAcceptAccount = () => {}, onPressAcceptBene = () => {} } = props;
  const { t } = useTranslation();
  const { colors, fonts } = useTheme();
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const isMobile = useMobileMediaQuery();

  const listBeneStore = useSelector(getListBeneSelector);
  const listAccountStore = useSelector(getListAccountSelector);
  const pending = useSelector(getPendingBeneSelector);

  const [searchKey, setSearchKey] = React.useState<string>("");
  const [offset, setOffset] = React.useState<number>(0);

  const [listDataBene, setListDataBene] = React.useState<FlatListItem[]>([]);
  const [listDataBeneNew, setListDataBeneNew] = React.useState<TRANSPROFILE[]>([]);

  const [dataProvider] = React.useState<DataProvider>(
    new DataProvider((r1, r2) => {
      return r1 !== r2;
    }),
  );

  const [layoutProvider] = React.useState<LayoutProvider>(
    new LayoutProvider(
      (index) => {
        if (arrayHeader.length && arrayHeader.includes(index)) {
          return ViewTypes.HEADER;
        }
        return ViewTypes.LISTITEM;
      },
      (type, dim) => {
        switch (type) {
          case ViewTypes.HEADER:
            dim.width = isMobile ? width * 0.9 : 550 - spacing.huge * 2;
            dim.height = spacing.macro;
            break;
          case ViewTypes.LISTITEM:
            dim.width = isMobile ? width * 0.9 : 550 - spacing.huge * 2;
            dim.height = isMobile ? spacing.galactic + 30 : spacing.galactic;
            break;
          default:
            dim.width = 100;
            dim.height = 100;
            break;
        }
      },
    ),
  );

  const textInputCommonProps: object = {
    style: {
      color: colors.accent,
      backgroundColor: colors.surface,
      fontWeight: "700",
      textShadowColor: "black",
      marginHorizontal: spacing.huge,
    },
    mode: "outlined",
    outlineColor: colors.divider,
    theme: {
      colors: {
        primary: colors.accent,
        text: colors.accent,
      },
    },
  };

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        flatList: {
          flex: 1,
          paddingHorizontal: spacing.huge,
          minHeight: 100,
        },
        titleModal: {
          color: colors.accent,
          fontFamily: fonts.medium.fontFamily,
        },
      }),
    [colors.accent, fonts.medium.fontFamily],
  );

  const loadMore = () => {
    console.log("loadMore");
    if (!pending && offset > 0 && listBeneStore && listBeneStore.length >= LIMIT_BENE) {
      dispatch(fetchListBeneRequest({ limit: LIMIT_BENE, offset: offset, searchKey: searchKey, templateType: templateType }));
    }
  };

  const onChangeSearch = () => {
    setOffset(0);
    setListDataBene([]);
    dispatch(fetchListBeneRequest({ limit: LIMIT_BENE, offset: 0, searchKey: searchKey, templateType: templateType }));
  };

  const onPressChoose = (item: FlatListItem) => {
    if (item.type === TYPE_CHOOSE_BENE.ACCOUNT) {
      onPressAcceptAccount(item.data);
    }
    if (item.type === TYPE_CHOOSE_BENE.BENE) {
      onPressAcceptBene(item.data);
    }
  };

  const getListAccount = () => {
    let list: ACCOUNT[] = [];
    if (listAccountStore?.ACCOUNT?.length && templateType === Constant.TEMPLATE_TYPE.INTERNAL_TRANSFER) {
      list = listAccountStore?.ACCOUNT;
      if (account?.ACCOUNTNO?.length) {
        const filterAcc = list.filter((item) => {
          return (
            item.ACCOUNTNO !== account?.ACCOUNTNO &&
            item.ACCOUNTTYPE === Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT &&
            item.CURRENCYCODE === "VND"
          );
        });
        list = filterAcc;
      }
    }
    return mapAccountPayments(list);
  };

  const mapDataListAccounts = () => {
    const list: FlatListItem[] = [];
    const listAccount = getListAccount();
    if (templateType === Constant.TEMPLATE_TYPE.INTERNAL_TRANSFER && listAccount.length) {
      listAccount.forEach((acc: ACCOUNT) => {
        const obj: FlatListItem = {
          data: acc,
          type: TYPE_CHOOSE_BENE.ACCOUNT,
          label: acc.ACCOUNTNO || "",
          value: formatCurrency(acc.AVAILABLEBALANCE, acc.CURRENCYCODE),
        };
        list.push(obj);
      });
    }
    return list;
  };

  const mapDataListBene = React.useCallback(
    (listNew?: TRANSPROFILE[]) => {
      const list: FlatListItem[] = [];
      // handlerListBeneficiaries(listNew, templateType);
      const listBene = handlerListBene(listNew, templateType);
      if (listBene.length) {
        listBene.forEach((bene: PROFILE_BENE) => {
          const obj: FlatListItem = {
            data: bene,
            type: TYPE_CHOOSE_BENE.BENE,
            label: bene.NAME || "",
            value: bene.ACCOUNT_NUMBER || bene.CARD_NUMBER || bene.CARD_NUMBER || "",
          };
          list.push(obj);
        });
      }
      return list;
    },
    [templateType],
  );

  const getDataProvider = () => {
    let dataList: FlatListItem[] = [];
    const listAccounts = mapDataListAccounts();
    if (listAccounts.length) {
      arrayHeader = [0];
      dataList.push({
        header: { left: t("BENE_TAI_KHOAN_CUA_TOI"), right: t("ACC_SO_DU_KHA_DUNG") },
      });
    }
    dataList = dataList.concat(listAccounts);
    if (listDataBene.length && dataList.length) {
      arrayHeader.push(dataList.length);
    }
    if (listDataBene.length) {
      dataList.push({
        header: { left: getHeaderLeft(templateType), right: getHeaderRight(templateType) },
      });
    }
    dataList = dataList.concat(listDataBene);
    return dataProvider.cloneWithRows(dataList);
  };

  React.useEffect(() => {
    dispatch(fetchListBeneRequest({ limit: LIMIT_BENE, offset: 0, templateType: templateType }));
  }, [dispatch, templateType]);

  React.useEffect(() => {
    if (listBeneStore && listBeneStore.length >= 0 && !pending) {
      setListDataBeneNew(listBeneStore);
    }
  }, [listBeneStore, pending]);

  React.useEffect(() => {
    if (listDataBeneNew.length) {
      const listBeneNew = mapDataListBene(listDataBeneNew);
      setListDataBeneNew([]);
      setOffset(offset + LIMIT_BENE);
      setListDataBene(listDataBene.concat(listBeneNew));
    }
  }, [listDataBene, listDataBeneNew, offset, mapDataListBene]);

  const TitleModal = (
    <React.Fragment>
      <Block ph={spacing.huge} pv={spacing.medium}>
        <Title style={styles.titleModal}>{title || t("BENE_CHON_TK_THU_HUONG")}</Title>
      </Block>
    </React.Fragment>
  );

  const FormEmpty =
    !pending && !listDataBene.length ? (
      <Block flex={1} pv={spacing.massive} center middle>
        <Paragraph style={[fonts.regular, { color: colors.blackText }]}>
          {searchKey?.length ? t("BENE_KHONG_CO_THONG_TIN_YEU_CAU") : t("BENE_CHUA_CO_THONG_TIN_THU_HUONG")}
        </Paragraph>
      </Block>
    ) : (
      <Block h={spacing.medium} />
    );

  const renderFooter = pending ? (
    <Block center middle pv={spacing.small}>
      <ActivityIndicator color={colors.primary} size={"small"} />
    </Block>
  ) : (
    FormEmpty
  );

  const renderItem = (type: string | number, item: any, index: number) => {
    return <ItemBeneAccountModal item={item} index={index} templateType={templateType} onClick={onPressChoose} />;
  };

  return (
    <>
      {TitleModal}
      <TextInput
        {...textInputCommonProps}
        label={t("COMMON_TIM_KIEM")}
        value={searchKey}
        onChangeText={setSearchKey}
        onKeyPress={(e) => {
          if (e.nativeEvent.key === "Enter") {
            onChangeSearch();
          }
        }}
        left={<TextInput.Icon name="account-search-outline" size={spacing.huge} />}
        right={<TextInput.Icon name="text-search" size={spacing.huge} onPress={onChangeSearch} />}
      />
      <RecyclerListView
        style={styles.flatList}
        dataProvider={getDataProvider()}
        layoutProvider={layoutProvider}
        onScroll={({ nativeEvent: { contentSize, layoutMeasurement, contentOffset } }) => {
          const distanceFromEnd = (contentSize?.height || 0) - (layoutMeasurement?.height || 0) - contentOffset.y;
          if (distanceFromEnd < 0) return false;
        }}
        onEndReached={() => loadMore()}
        rowRenderer={renderItem}
        renderFooter={() => renderFooter}
      />
    </>
  );
};

export default SelectAccountsBeneModal;
